import './event-schedule.styles.css';

const Eventschedule = () =>{
    return(
        <div style={{boxSizing:'border-box',color:'black',marginTop:'15px'}}>
            <h1 style={{color:'white'}}>Event Schedule</h1>
            <div className="sch-timeline">
        <div className="sch-container sch-left">
    <div className="sch-content">
      <h2>20th february</h2>
      <table className="sch-table">
        <thead>
            <tr className="sch-tr">
                <th className="sch-th" scope="col">#</th>
                <th className="sch-th" scope="col">Event</th>
                <th className="sch-th" scope="col">Time</th>
            </tr>
        </thead>
        <tbody>
        <tr className="sch-tr">
            <th className="sch-th" scope="row">1</th>
            <td className="sch-td" >Speaker Session 1</td>
            <td className="sch-td"> 4:00-5:00 PM </td>
        </tr>
        <tr className="sch-tr">
            <th className="sch-th" scope="row">1</th>
            <td className="sch-td">Quiz-O-Quest Round 1</td>
            <td className="sch-td">6:00-6:30 PM</td>
            </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div className="sch-container sch-right">
    <div className="sch-content">
      <h2>21th february</h2>
      <table className="sch-table">
        <thead>
            <tr className="sch-tr">
                <th className="sch-th" scope="col">#</th>
                <th className="sch-th" scope="col">Event</th>
                <th className="sch-th" scope="col">Time</th>
            </tr>
        </thead>
        <tbody>
        <tr className="sch-tr">
            <th className="sch-th" scope="row">1</th>
            <td className="sch-td" >Loop Of Codes</td>
            <td className="sch-td">12:00-5:00 PM</td>
        </tr>
        <tr className="sch-tr">
            <th className="sch-th" scope="row">1</th>
            <td className="sch-td">Quiz-O-Quest Round 2</td>
            <td className="sch-td">6:30-7:00 PM</td>
            </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div className="sch-container sch-left">
    <div className="sch-content">
      <h2>22th february</h2>
      <table className="sch-table">
        <thead>
            <tr className="sch-tr">
                <th className="sch-th" scope="col">#</th>
                <th className="sch-th" scope="col">Event</th>
                <th className="sch-th" scope="col">Time</th>
            </tr>
        </thead>
        <tbody>
        <tr className="sch-tr">
            <th className="sch-th" scope="row">1</th>
            <td className="sch-td" >Speaker Session 2</td>
            <td className="sch-td">6:00-7:00 PM</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div className="sch-container sch-right">
    <div className="sch-content">
      <h2>23th february</h2>
            <table className="sch-table">
        <thead>
            <tr className="sch-tr">
                <th className="sch-th" scope="col">#</th>
                <th className="sch-th" scope="col">Event</th>
                <th className="sch-th" scope="col">Time</th>
            </tr>
        </thead>
        <tbody>
        <tr className="sch-tr">
            <th className="sch-th" scope="row">1</th>
            <td className="sch-td" >D2D Round 1</td>
            <td className="sch-td">6:00-7:00 PM</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div className="sch-container sch-left">
    <div className="sch-content">
      <h2>24th february</h2>
      <table className="sch-table">
        <thead>
            <tr className="sch-tr">
                <th className="sch-th" scope="col">#</th>
                <th className="sch-th" scope="col">Event</th>
                <th className="sch-th" scope="col">Time</th>
            </tr>
        </thead>
        <tbody>
        <tr className="sch-tr">
            <th className="sch-th" scope="row">1</th>
            <td className="sch-td" >Speaker Session 3</td>
            <td className="sch-td">7:00-8:00 PM</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div className="sch-container sch-right">
    <div className="sch-content">
      <h2>25th february</h2>
      <table className="sch-table">
        <thead>
            <tr className="sch-tr">
                <th className="sch-th" scope="col">#</th>
                <th className="sch-th" scope="col">Event</th>
                <th className="sch-th" scope="col">Time</th>
            </tr>
        </thead>
        <tbody>
        <tr className="sch-tr">
            <th className="sch-th" scope="row">1</th>
            <td className="sch-td" >D2D Round 2</td>
            <td className="sch-td">6:00-7:00 PM</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div className="sch-container sch-left">
    <div className="sch-content">
      <h2>26th february</h2>
      <table className="sch-table">
        <thead>
            <tr className="sch-tr">
                <th className="sch-th" scope="col">#</th>
                <th className="sch-th" scope="col">Event</th>
                <th className="sch-th" scope="col">Time</th>
            </tr>
        </thead>
        <tbody>
        <tr className="sch-tr">
            <th className="sch-th" scope="row">1</th>
            <td className="sch-td" >KasParable</td>
            <td className="sch-td">All day</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div className="sch-container sch-right">
    <div className="sch-content">
      <h2>27th february</h2>
      <table className="sch-table">
        <thead>
            <tr className="sch-tr">
                <th className="sch-th" scope="col">#</th>
                <th className="sch-th" scope="col">Event</th>
                <th className="sch-th" scope="col">Time</th>
            </tr>
        </thead>
        <tbody>
        <tr className="sch-tr">
            <th className="sch-th" scope="row">1</th>
            <td className="sch-td" >KasParable</td>
            <td className="sch-td">All day</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div className="sch-container sch-left">
    <div className="sch-content">
      <h2>28th february</h2>
      <table className="sch-table">
        <thead>
            <tr className="sch-tr">
                <th className="sch-th" scope="col">#</th>
                <th className="sch-th" scope="col">Event</th>
                <th className="sch-th" scope="col">Time</th>
            </tr>
        </thead>
        <tbody>
        <tr className="sch-tr">
            <th className="sch-th" scope="row">1</th>
            <td className="sch-td" >Quiz-O-Quest Round 3</td>
            <td className="sch-td">1:00-4:00 PM</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
        </div>
    )
}

export default Eventschedule;
